import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NotificationService} from "../../../services/notification.service";

@Component({
  selector: 'app-help-utility',
  templateUrl: './help-utility.component.html',
  styleUrl: './help-utility.component.scss'
})
export class HelpUtilityComponent implements OnChanges {

  @Input() msaadaAiToggle: boolean = false;

  notify = inject(NotificationService);

  viewType: 'msaadaAi' | 'chatCenter' | 'accessibility' | 'newsUpdate' | undefined = undefined;

  private changeCount = 0;
  isLoading: boolean = true;

  comingSoon(){
    this.notify.infoMessage("Coming Soon...!");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['msaadaAiToggle']) {
      this.changeCount++;

      if (this.changeCount >= 2) {
        this.viewType = 'msaadaAi';
      }
    }
  }



}
